import React from "react";
import PropTypes from "prop-types";
import GonkBox from "views/GonkBox";

const DEFAULT_MESSAGE = "Unknown Error";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    componentDidCatch(error, info) {
        // send to monitoring, perhaps?
        const isRealError = error instanceof Error;
        this.setState({
            hasError: true,
            error: isRealError ? error : null,
            info,
            message: (isRealError
                ? error.message
                : error == null
                    ? null
                    : error.toString()) || DEFAULT_MESSAGE,
        });
    }

    render() {
        if (this.state.hasError) {
            const {
                error,
                message,
            } = this.state;
            return <GonkBox>
                <h2>Uncaught {(error && error.name) || "Error"}</h2>
                <p>{message}</p>
            </GonkBox>;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./app/lib/common/components/ErrorBoundary.js